module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM2000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "add-checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-clients",
      "placeholder": _vm.lang.CM2001,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.$emit('clientSelected', _vm.selectedClientLocal)
      }
    },
    model: {
      value: (_vm.selectedClientLocal),
      callback: function($$v) {
        _vm.selectedClientLocal = $$v
      },
      expression: "selectedClientLocal"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers') ?
      'col-md-2' :
      'col-md-4'
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-projects",
      "disabled": !_vm.selectedClientLocal,
      "placeholder": _vm.lang.CM2002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProjectLocal),
      callback: function($$v) {
        _vm.selectedProjectLocal = $$v
      },
      expression: "selectedProjectLocal"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-surveys",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2003,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSurvey),
      callback: function($$v) {
        _vm.selectedSurvey = $$v
      },
      expression: "selectedSurvey"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.surveysOfProject), function(survey) {
    return _c('option', {
      key: survey.SurveyId,
      domProps: {
        "value": survey.SurveyId
      }
    }, [_vm._v("\n                      " + _vm._s(survey.SurveyTitle) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-waves",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                      " + _vm._s(wave.WaveName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-scenarios",
      "disabled": !_vm.selectedWave,
      "placeholder": _vm.lang.CM2005,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedScenario),
      callback: function($$v) {
        _vm.selectedScenario = $$v
      },
      expression: "selectedScenario"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                      " + _vm._s(scenario.ScenarioName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), (
    _vm.feature.isAudiTarget && _vm.feature.isEnabled('leadAgencies')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-lead-agency",
      "placeholder": _vm.lang.CM2013,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedUser = ''
      }
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                      " + _vm._s(agency.AgencyName) + "\n                    ")])
  })], 2)], 1)]) : _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-check-types",
      "placeholder": _vm.lang.CM2031,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        (_vm.selectedUser = ''), (_vm.selectedAgency = '')
      }
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2032))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2033))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2034))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2029,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedBriefingGuid),
      callback: function($$v) {
        _vm.selectedBriefingGuid = $$v
      },
      expression: "selectedBriefingGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                      " + _vm._s(briefing.FileName) + "\n                    ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2030,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                      " + _vm._s(survey.FileName) + "\n                    ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGlobalAmount"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globalAmount),
      expression: "globalAmount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "inputGlobalAmount"
    },
    domProps: {
      "value": (_vm.globalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalAmount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkInfo),
      expression: "checkInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.lang.CM2044
    },
    domProps: {
      "value": (_vm.checkInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkInfo = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.selectedCheckType === 'AG' && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2013,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedUser = ''
      }
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                      " + _vm._s(agency.AgencyName) + "\n                    ")])
  })], 2)], 1)]) : (_vm.selectedCheckType === 'MA') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM2006,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.selectedAgency = ''
      }
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.shopperList), function(user, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(user) + "\n                    ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.selectedCheckType === 'FO' &&
    _vm.feature.isEnabled('freeOffers')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showFurtherSettingsModal = true
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2038))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchAddChecks",
      "placeholder": _vm.lang.CM2014
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('div', {
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(!_vm.isPageSelected()) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM2011))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM2012))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('span', {
    staticClass: "selected-locations-counter"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM2037) + ": " + _vm._s(_vm.selectedLocations.length || 0) + "\n                  "), (_vm.selectedLocations.length) ? [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectedLocations = []
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2036))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdownAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2015))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2016))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2017))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "addChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "addChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2045))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default locations-table-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "possibleLocations"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2018) + "\n                        "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2019) + "\n                        "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCountry')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2020) + "\n                        "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationAddress')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2021) + "\n                        "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationProperties')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2022) + "\n                        "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStatusId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2023) + "\n                        "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('SurveyInstancesCount')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2024) + "\n                        "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header"
  }, [_vm._v(_vm._s(_vm.lang.CM2009))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationId),
      expression: "filterStrings.LocationId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationProperties),
      expression: "filterStrings.LocationProperties"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationProperties)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationProperties", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStatusId),
      expression: "filterStrings.LocationStatusId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStatusId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstancesCount),
      expression: "filterStrings.SurveyInstancesCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstancesCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstancesCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "create-checks-table"
    }
  }, _vm._l((_vm.locationData), function(location) {
    return _c('tr', {
      key: location.LocationId,
      class: {
        info: _vm.isLocationSelected(location.LocationId),
        'location-inactive': location.LocationStatusId === 'X',
        'location-temp-inactive': location.LocationStatusId === 'T',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleLocationSelected(location.LocationId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(location.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationAddress) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationProperties) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationStatusId) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.SurveyInstancesCount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (location.Amount),
        expression: "location.Amount",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control nopadding",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (location.Amount)
      },
      on: {
        "click": function($event) {
          return $event.stopPropagation()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(location, "Amount", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2039) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "check-management-create",
      "type": "button",
      "disabled": _vm.selectedLocations.length < 1 ||
        !_vm.selectedSurvey ||
        !_vm.selectedScenario ||
        (!_vm.selectedUser && !_vm.selectedAgency && _vm.selectedCheckType !== 'FO')
    },
    on: {
      "click": function($event) {
        return _vm.createChecks()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2026) + "\n          ")])])])])]), _vm._v(" "), _c('AddChecksFurtherSettingsModal', {
    ref: "addChecksFurtherSettingsModal",
    attrs: {
      "showModal": _vm.showFurtherSettingsModal,
      "survey": _vm.selectedSurveyData
    },
    on: {
      "modalClosed": _vm.furtherSettingsModalClosed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdownAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6ddafe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/CheckManagementAddModal.vue
// module id = 1659
// module chunks = 1